<template>
  <div id="scroll-target">
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0">
        <b-form-select
          style="width: 100%"
          v-model="form_id"
          :options="forms"
          class="mt-1"
          @change="onFormChanged()"
        />
      </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <ul class="demo-alignment pb-0" style="float: right">
            <!-- 
            <li>
              <vs-checkbox
                v-model="published_only"
                color="primary"
                :vs-value="true"
                @change="refreshTable()"
                >Published Only</vs-checkbox
              >
            </li>
            -->
            <li class="pl-4 border-0 border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        id="sector"
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :fields="columns"
        :items="dataProvider"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
        :no-provider-sorting="true"
      >
        <template v-slot:cell(sector)="data">
          <div>
            {{ data.value }}
          </div>
        </template>

        <!-- A custom formatted footer cell for field 'name' -->
        <template #foot()="data">
          <div style="font-weight: bolder; font-size: 1.1rem">
            <b>{{ data.field.foot }}</b>
          </div>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>
      </b-table>

      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx

export default {
  components: {},
  data: () => ({
    order_id: null,
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    fields: [],
    columns: [],
    footer: [],
    items: [],
    form_id: "field_a1",
    sector: { title: "" },
    forms: [],
    published_only: false,
    answerOptions: []
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;

    this.getForms();
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    getForms() {
      Service.Event.get(this.$route.query.e).then(res => {
        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(key => {
          if (res.data.event["field_q" + key] != null) {
            this.forms.push({
              text: res.data.event["field_q" + key],
              value: "field_a" + key
            });
          }
        });
      });
    },
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
          filter: this.form_id,
          perPage: 30,
          currentPage: 1
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        this.columns = [
          { label: "Answer", key: "answer", sortable: true, foot: "" },
          { label: "Total", key: "total", sortable: true, foot: "" },
          {
            label: "Percentage",
            key: "percentage",
            sortable: true,
            foot: ""
          }
        ];

        return Service.Report.sector(params).then(res => {
          this.sector = res.data.sector;

          // if (res.data.sector.type == "text" || res.data.sector.type == "tel") {
          //   this.columns = [
          //     // {
          //     //   label: "Sector",
          //     //   key: "sector",
          //     //   sortable: true,
          //     //   foot: "",
          //     // },
          //     { label: "Answer", key: "answer", sortable: true, foot: "" },
          //     { label: "Total", key: "total", sortable: true, foot: "" },
          //     {
          //       label: "Percentage",
          //       key: "percentage",
          //       sortable: true,
          //       foot: "",
          //     },
          //   ];
          // }

          this.columns = [
            { label: "Answer", key: "answer", sortable: true, foot: "" },
            { label: "Total", key: "total", sortable: true, foot: "" },
            {
              label: "Percentage",
              key: "percentage",
              sortable: true,
              foot: ""
            }
          ];

          this.data = res.data.series.map(item => {
            return { ...item };
          });
          callback(this.data);
        });
      }, 500);
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    onFormChanged() {
      this.$refs.table.refresh();
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      rows = this.data.map((item, index) => {
        let data = {};
        let datetime = null;
        this.columns.map(col => {
          if (col.key.split("_")[0] == "answer") {
            let found = this.columns.find(x => x.key == col.key);
            data[found.label] = item[col.key];
          } else {
            data[col.key] = item[col.key];
          }
        });

        if (item.is_published) {
          datetime = item.published_at;
        } else {
          datetime = item.create_at;
        }
        /*
        let data = {
          Status: item.status,
          Ticket: item.ticket.ticket,
          Name: item.ticket.firstName + " " + item.ticket.lastName,
          Area: item.ticket.field_a1,
          Club: item.ticket.field_a2,
          Date: datetime
        };
        */
        return data;
      });

      let filename = this.forms.find(x => x.value == this.form_id).text;

      let dataExport = {};

      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      /* header */
      // XLSX.utils.sheet_add_aoa(dataWS, [[filename, "", ""]], {
      //   origin: "A1"
      // });
      XLSX.utils.sheet_add_aoa(dataWS, [["Answer", "Total", "Percentage"]], {
        origin: "A1"
      });

      XLSX.utils.book_append_sheet(wb, dataWS);

      XLSX.writeFile(wb, "vote_report_" + filename + ".xlsx");
      this.$vs.loading.close();
    }
  }
};
</script>
<style lang="scss">
#sector tbody > tr:last-child {
  td {
    font-size: 1.1rem !important;
    font-weight: bold !important;
  }
}
</style>
